export default "__VITE_ASSET__BZ$1IuYr__"